module.exports = __webpack_public_path__ + "static/media/chrome-web-store-badge.ca4725e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/chrome-web-store-badge.svg
// module id = 2926
// module chunks = 0